import React, { useEffect } from 'react'
import { Box } from '@mui/material'
import NewHeroSection from './NewHeroSection'
import HowItWorks from './HowItWorks'
import VideoShowcase from './VideoShowcase'
import FeaturedServices from './FeaturedServices'
import AiFeaturesSection from './AiFeaturesSection'
import ContactSection from './ContactSection'
import Footer from 'components/Layout/Footer'

const HomePage = () => {
  useEffect(() => {
    document.title = 'AI-Powered Medical Job Search | MyStethi Healthcare Platform'

    let metaDescription = document.querySelector('meta[name="description"]')
    if (!metaDescription) {
      metaDescription = document.createElement('meta')
      metaDescription.name = 'description'
      document.head.appendChild(metaDescription)
    }
    metaDescription.content = 'Find medical jobs with MyStethi\'s AI-powered job search. Ask questions about any role, get intelligent matches, and connect directly with hospitals—no recruiter spam. Free for healthcare professionals.'

    const structuredData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "@id": "https://www.mystethi.com/#organization",
          "name": "MyStethi",
          "url": "https://www.mystethi.com",
          "description": "MyStethi is an AI-powered healthcare job platform connecting medical professionals with hospitals and health systems. Find clinician jobs, medical careers, and healthcare opportunities."
        },
        {
          "@type": "WebSite",
          "@id": "https://www.mystethi.com/#website",
          "url": "https://www.mystethi.com",
          "name": "MyStethi - AI-Powered Medical Job Search",
          "description": "Find medical jobs with MyStethi's AI-powered job search. Ask questions about any role, get intelligent matches, and connect directly with hospitals.",
          "publisher": {
            "@id": "https://www.mystethi.com/#organization"
          },
          "potentialAction": {
            "@type": "SearchAction",
            "target": "https://www.mystethi.com/jobs?search={search_term_string}",
            "query-input": "required name=search_term_string"
          }
        }
      ]
    }

    let structuredDataScript = document.getElementById('homepage-structured-data')
    if (!structuredDataScript) {
      structuredDataScript = document.createElement('script')
      structuredDataScript.id = 'homepage-structured-data'
      structuredDataScript.type = 'application/ld+json'
      document.head.appendChild(structuredDataScript)
    }
    structuredDataScript.textContent = JSON.stringify(structuredData)

    return () => {
      const script = document.getElementById('homepage-structured-data')
      if (script) {
        document.head.removeChild(script)
      }
    }
  }, [])

  return (
    <Box component="main" sx={{ width: '100%' }}>
      <NewHeroSection />
      <Box component="section" aria-label="See MyStethi in action">
        <VideoShowcase />
      </Box>
      <Box component="section" aria-label="Why MyStethi is different">
        <HowItWorks />
      </Box>
      <Box component="section" aria-label="Platform tools and features">
        <FeaturedServices />
      </Box>
      <Box component="section" aria-label="AI-powered features">
        <AiFeaturesSection />
      </Box>
      <Box component="section" aria-label="Get started with MyStethi">
        <ContactSection />
      </Box>
      <Footer />
    </Box>
  )
}

export default HomePage
